// src/components/RightsWelcomeCard.js - RULING 306 item 2 (Bob 2026-10-12, "all"): a member's welcome card - read once,
// closed with one click, nothing signed or acknowledged. Remembered in this browser only (as the ruling-259 address reminder
// is); a member on another device may see it once more, which is harmless. The text is src\data\lmrdaRights.js.
import React, { useState } from 'react';
import { WELCOME_KEY, showWelcomeCard } from '../data/lmrdaRights';
import { activate } from '../data/a11yActivate';   // pass 2: role, tabIndex and Enter/Space from one tested helper

function readClosed(uid) { try { return window.localStorage.getItem(WELCOME_KEY(uid)) === '1'; } catch (e) { return false; } }

export default function RightsWelcomeCard({ user, onNavigate }) {
  const [closed, setClosed] = useState(() => readClosed(user && user.uid));
  if (!showWelcomeCard(user, closed)) return null;
  const close = () => { try { window.localStorage.setItem(WELCOME_KEY(user.uid), '1'); } catch (e) { /* the card just closes */ } setClosed(true); };
  return (
    <div className="card" style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
      <div style={{ fontSize: 13, color: '#F4F6F8', lineHeight: 1.5 }}>
        <b>Your rights as a member of SMART-TD.</b> The law asks every union to tell its members about the rights the
        LMRDA gives them - equal rights in the union, free speech, a fair hearing, copies of your agreements, and fair elections.
        {onNavigate ? <span style={{ color: '#E8A020', cursor: 'pointer', marginLeft: 6 }} {...activate(() => onNavigate('member-rights'))}>Read them</span> : null}
      </div>
      <span style={{ fontSize: 12, color: '#8AA4BF', cursor: 'pointer', whiteSpace: 'nowrap' }} {...activate(close)}>Close</span>
    </div>
  );
}
